module.exports = __webpack_public_path__ + "assets/img/attention.a91b3c81.svg";